import EA from '../helpers/init';

export default EA.Methods.mobileMenuHandler = ($this) => {
    const mobileMenuToggle = $this.querySelector('.menu-toggle-btn');
    const mobileMenu = $this.querySelector('.mobile-menu');

    const mobileMenuCloseBtn = $this.querySelector('.menu-close-btn');

    const bodyChildren = [...document.getElementById('app').children].filter(
        el => !el.contains(mobileMenu) && el.id !== 'wpadminbar'
    );

    const openMenu = () => {
        if(!mobileMenu) return;

        mobileMenu.classList.add('active');
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
        mobileMenuToggle.setAttribute('aria-label', 'Close mobile menu');
        document.body.style.overflow = 'hidden';    
        bodyChildren.forEach(el => el.inert = true);

        mobileMenuCloseBtn.focus();
    };

    const closeMenu = () => {
        if(!mobileMenu) return;

        mobileMenu.classList.remove('active');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        mobileMenuToggle.setAttribute('aria-label', 'Open mobile menu');
        document.body.style.overflow = 'auto';
        bodyChildren.forEach(el => el.inert = false);

        mobileMenuToggle.focus();
    };

    const isMenuOpen = () => mobileMenu.classList.contains('active');

    const focusableSelectors = 'a, button, [tabindex]:not([tabindex="-1"])';

    mobileMenuToggle.addEventListener('click', () => {
        if(isMenuOpen()) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    mobileMenuCloseBtn.addEventListener('click', () => {
        closeMenu();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMenuOpen()) {
            closeMenu();
            return;
        }

        if(e.key === 'Tab' && isMenuOpen()) {
            const focusable = [...mobileMenu.querySelectorAll(focusableSelectors)];
            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });
};